import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Planos from './Planos';
import Orientacao from './Orientacao';
import * as FcIcons from "react-icons/fc";

import './styles.css';

const Telefone = () => {
  const location = useLocation();

  useEffect(() => {
    const activeTabFromUrl = location.pathname;
    setActiveTab(activeTabFromUrl);
  }, [location.pathname]);

  const [activeTab, setActiveTab] = useState('');

  const handleTabSelect = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  useEffect(() => {
    if (!activeTab) {
      setActiveTab('/planos');
    }
  }, [activeTab]);

  return (
    <div>
      <br />
      <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
        <Nav fill variant="tabs" defaultActiveKey="/planos">
          <Nav.Item>
            <Nav.Link eventKey="/planos">
              <div className='aba-menu'>
                <h4><FcIcons.FcCurrencyExchange /></h4>
                <h5>Planos de Telefone</h5>
              </div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="/orientacao">
              <div className='aba-menu'>
                <h4><FcIcons.FcAbout /></h4>
                <h5>Orientações básicas</h5>
              </div>
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          {activeTab === '/planos' && (
            <Tab.Pane eventKey="/planos">
              <Planos />
            </Tab.Pane>
          )}
          {activeTab === '/orientacao' && (
            <Tab.Pane eventKey="/orientacao">
              <Orientacao />
            </Tab.Pane>
          )}

        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default Telefone;
